/**
 * LIMPIA TODOS LOS CAMPOS DE LA APPLICACIÓN
 * @param {Function} setData 
 */
const limpiarCampos = (setData, setObservaciones, setAnualidad, setFolio, setNuevosTramites, setListaEstatus, setListaUsuarios, setIdTramite, setIdConceptoPago) => {
    setData({});
    setObservaciones("");
    setAnualidad("");
    setFolio("");
    setNuevosTramites([]);
    setListaEstatus([]);
    setListaUsuarios([]);
    setIdTramite(0);
    setIdConceptoPago(0);
}

export default limpiarCampos;